import service from '@/config/axios'

// 获取 Collection 分类列表
const getCategoryList = () => {
  return service.get('/api/product/category/list')
}

// 获取产品列表（支持分页和分类筛选）
const getProductList = (params) => {
  return service.get('/api/product/list', { params })
}

// 获取产品详情（支持设备类型参数）
const getProductDetail = (productId, device = 'pc') => {
  return service.get(`/api/product/${productId}`, { params: { device } })
}

// 搜索产品
const searchProducts = (params) => {
  return service.get('/api/product/search', { params, rawResponse: true })
}

// 获取推荐产品
const getRecommendedProducts = (count = 4) => {
  return service.get('/api/product/recommended', { params: { count } })
}

// 获取分类详情（产品浏览页初始化数据）- 支持设备类型参数
const getCategoryDetail = (categoryId, device = 'pc') => {
  return service.get('/api/product/category/detail', { 
    params: { 
      CategoryID: categoryId,
      device: device 
    } 
  })
}

export {
  getCategoryList,
  getProductList,
  getProductDetail,
  searchProducts,
  getRecommendedProducts,
  getCategoryDetail
}